<template>
    <div class="notificacao-mensagens-lista scroll-y overflow-x-hidden ma-1">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'NotificacaoMensagemLista',
    async mounted(){
        await this.addEventoScroll()
    },
    methods: {
        async addEventoScroll(){
            const chatBody = document.querySelector('div.notificacao-mensagens-lista')
            chatBody.addEventListener('scrollend', () => {
                const scrollBarNoFinal = chatBody.scrollTop == (chatBody.scrollHeight - chatBody.offsetHeight)
                if(scrollBarNoFinal)
                    this.$emit('carregarMaisMensagens')
            })
        },
    }
}
</script>

<style scoped lang="stylus">
    .notificacao-mensagens-lista
        height auto !important
        max-height calc(100vh * .6) !important

</style>